/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pin': {
    width: 16,
    height: 16,
    viewBox: '0 0 100 100',
    data: '<path pid="0" d="M38 5c-4.379 0-8 3.621-8 8 0 3.063 1.816 5.688 4.375 7.031l-5.094 19.625C23.961 42.5 20 46.672 20 52a3 3 0 003 3h24v37c-.023 1.586 1.414 3.063 3 3.063s3.023-1.477 3-3.063V55h24a3 3 0 003-3c0-5.328-3.96-9.5-9.281-12.344l-5.094-19.625C68.184 18.687 70 16.062 70 13c0-4.379-3.621-8-8-8zm0 6h24c1.16 0 2 .84 2 2s-.84 2-2 2c-.93 0-1.805.43-2.371 1.164a2.994 2.994 0 00-.535 2.586l6.125 23.625a3 3 0 001.625 1.969c2.984 1.402 4.89 3.035 6 4.656H27.156c1.11-1.621 3.015-3.254 6-4.656a3 3 0 001.625-1.969l6.125-23.625a2.994 2.994 0 00-.535-2.586A2.992 2.992 0 0037.999 15c-1.16 0-2-.84-2-2s.84-2 2-2z"/>'
  }
})
